import { grid, border } from 'styled-system';
import styled from 'styled-components';

import Box from '../Box';

const Grid = styled(Box)`
  display: grid;
  ${grid};
  ${border};
`;

export default Grid;
